import api from '../../config/axios';

class PartnerService {
  async fetchPartnerProfile(phone_no: string) {
    const response = await api.post('/users/larkdata', { phone_no });
    return response.data;
  }

  async updateApplicationStatus(userId: string, status: string) {
    const response = await api.put(`/auth/update-application-status/${userId}`, {
      status
    });
    return response.data;
  }
}

const partnerService = new PartnerService();
export default partnerService;